"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _GenericField = _interopRequireDefault(require("./GenericField"));

var _ReadOnly = _interopRequireDefault(require("./ReadOnly"));

var _adapters = _interopRequireDefault(require("../adapters"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LayoutField = /*#__PURE__*/function (_React$Component) {
  _inherits(LayoutField, _React$Component);

  var _super = _createSuper(LayoutField);

  function LayoutField() {
    _classCallCheck(this, LayoutField);

    return _super.apply(this, arguments);
  }

  _createClass(LayoutField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          field = _this$props.field,
          form = _this$props.form,
          fieldId = _this$props.fieldId,
          sectionId = _this$props.sectionId,
          adapter = _this$props.adapter,
          adapters = _this$props.adapters,
          readOnly = _this$props.readOnly,
          otherProps = _objectWithoutProperties(_this$props, ["field", "form", "fieldId", "sectionId", "adapter", "adapters", "readOnly"]);

      var _field = field; // TODO: ASK JEFF IF THIS LOGIC NEEDS TO BE IN RENDER?

      if (!_field) {
        if (!form || !fieldId) {
          throw new Error('You must define either "field" OR "form AND fieldId" props in LayoutField');
        }

        try {
          if (sectionId) {
            _field = form.getFieldFromSection(fieldId, sectionId);
          } else {
            _field = form.$(fieldId);
          }
        } catch (error) {
          console.error(error);
          return null;
        }
      }

      if (!_field.isShown) {
        return null;
      }

      var _adapter = adapter || adapters[_field.type];

      if (!_adapter) {
        throw new Error("No adapter configured for field of type \"".concat(field.type, "\"."));
      }

      if (readOnly) {
        return /*#__PURE__*/_react.default.createElement(_ReadOnly.default, _extends({
          field: _field
        }, otherProps));
      }

      return /*#__PURE__*/_react.default.createElement(_GenericField.default, _extends({
        field: _field,
        adapter: _adapter,
        id: _field.id
      }, otherProps));
    }
  }]);

  return LayoutField;
}(_react.default.Component);

LayoutField.defaultProps = {
  adapter: null,
  adapters: _adapters.default,
  field: null,
  form: null,
  fieldId: null,
  sectionId: null,
  readOnly: false
};
LayoutField.propTypes = {
  //TODO: Custom validators as you can supply "field" OR "form, fieldId, sectionId"
  field: _propTypes.default.object,
  form: _propTypes.default.object,
  fieldId: _propTypes.default.string,
  sectionId: _propTypes.default.string,
  adapter: _propTypes.default.func,
  adapters: _propTypes.default.object,
  readOnly: _propTypes.default.bool
};

var _default = (0, _mobxReact.observer)(LayoutField);

exports.default = _default;
//# sourceMappingURL=LayoutField.js.map